export default function ScrollService(
    $timeout
) {
    'ngInject';

    Object.assign(this, {
        scrollToElement,
        scrollToTop,
    });

    const SELECTOR_HEAD = '.app-head';
    const PADDING_TOP = 100;

    function scrollToElement(selector) {
        const scrollTop = getSelectorOffset(selector) - getHeaderHeight();
        $timeout(() => getBody().animate({scrollTop}));
    }

    function getBody() {
        return angular.element('html,body');
    }

    function getHeaderHeight() {
        return angular.element(SELECTOR_HEAD).height() + PADDING_TOP;
    }

    function getSelectorOffset(selector) {
        return angular.element(selector).offset().top;
    }

    function scrollToTop() {
        const selectors = [
            'html',
            'body',
            '.container-app',
            '.container-app .main',
        ].join(', ');

        angular.element(selectors).scrollTop(0);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/services/scroll-service.js